import React from "react";
import styles from "./formColumn.module.scss";
const FormColumn = ({ children }) => {
    return React.createElement("div", { className: styles.root }, children);
};
FormColumn.displayName = "formColumn";
export default FormColumn;
//# sourceMappingURL=FormColumn.js.map